import * as Actions from "auth/store/actions";

const initialState = {
  success: false,
  isLoginLoading: false,
  error: null,
  cellphone: null,
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case Actions.LOGIN_START: {
      return {
        ...initialState,
        isLoginLoading: true,
      };
    }
    case Actions.LOGIN_SUCCESS: {
      return {
        ...initialState,
        success: true,
        isLoginLoading: false,
        cellphone: action.payload,
      };
    }
    case Actions.LOGIN_ERROR: {
      return {
        success: false,
        isLoginLoading: false,
        error: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default login;
